export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_lt.5685ac52a3287bc2.json"